import { wpApiInstance} from '../api/wp-api';

import { IWPResetUser } from '../models/user.interface';
import { handleRouteError } from './route-helpers/route-error';

/**
 * Posts a new user in WordPress.
 * 
 * @param {IUserWpNew} userID the form data
 */
const WpResetPasswordLink = async (userLogin: string, userID: string): Promise<IWPResetUser> => {
  try {

    const { data } = await wpApiInstance.get(`/admin/users/${userID}/email`,
      {
        params: {
          user: userLogin
        }
      }
    );

    return data;
  } catch (error) {
    handleRouteError(error, 'Error updating user');
    throw(error);
  }
}

export default WpResetPasswordLink;